import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowRight } from "lucide-react";
import { fetchPicks } from "@/lib/api";
import PickCard from "@/components/PickCard";
import SectionHeader from "@/components/SectionHeader";
import { Skeleton } from "@/components/ui/skeleton";

export function HomePicks({ onUnlock }) {
  const { data, isLoading } = useQuery({
    queryKey: ["home-picks"],
    queryFn: () => fetchPicks({ status: "pending", limit: 3 }),
  });

  return (
    <section className="border-y border-[#1E2738] bg-[#0A0D14]" data-testid="home-picks-section">
      <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 sm:py-24 lg:px-8">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <SectionHeader
            eyebrow="Upcoming Picks"
            title="On The Card Today"
            sub="Free picks are fully readable. VIP picks show the setup — members see the full analysis."
            testid="home-picks-header"
          />
          <Link
            to="/picks"
            data-testid="view-all-picks-btn"
            className="btn-outline mb-10 sm:mb-14 !px-5 !py-2.5"
          >
            All Picks <ArrowRight size={15} />
          </Link>
        </div>

        {isLoading ? (
          <div className="grid gap-4 sm:gap-6 md:grid-cols-3">
            {[...Array(3)].map((_, i) => <Skeleton key={i} className="h-96 rounded-xl bg-[#141A26]" />)}
          </div>
        ) : (
          <div className="grid gap-4 sm:gap-6 md:grid-cols-2 lg:grid-cols-3">
            {(data?.picks || []).map((p, i) => <PickCard key={p.id} pick={p} index={i} onUnlock={onUnlock} />)}
          </div>
        )}
      </div>
    </section>
  );
}

export default HomePicks;
